/* @generated from adl module ferovinum.app.product */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_strings from './../../common/strings';
import * as ferovinum_app_db from './db';
import * as ferovinum_app_dtos from './dtos';

export interface AssembledProductComponents {
  componentProductId: ferovinum_app_db.ProductId;
  quantity: number;
}

export function makeAssembledProductComponents(
  input: {
    componentProductId: ferovinum_app_db.ProductId,
    quantity: number,
  }
): AssembledProductComponents {
  return {
    componentProductId: input.componentProductId,
    quantity: input.quantity,
  };
}

const AssembledProductComponents_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.product","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"componentProductId","default":{"kind":"nothing"},"name":"componentProductId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ProductId"}},"parameters":[]}},{"annotations":[],"serializedName":"quantity","default":{"kind":"nothing"},"name":"quantity","typeExpr":{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}}]}},"name":"AssembledProductComponents","version":{"kind":"nothing"}}};

export const snAssembledProductComponents: ADL.ScopedName = {moduleName:"ferovinum.app.product", name:"AssembledProductComponents"};

export function texprAssembledProductComponents(): ADL.ATypeExpr<AssembledProductComponents> {
  return {value : {typeRef : {kind: "reference", value : snAssembledProductComponents}, parameters : []}};
}

export interface NewProductPackaging {
  numberOfItems: (number|null);
  packagingType: ferovinum_app_db.PackagingType;
  gtin: (common_strings.StringNE|null);
  gtinEffectiveDate: (common.LocalDate|null);
  height: (number|null);
  width: (number|null);
  depth: (number|null);
  weight: (number|null);
  casesPerTier: (number|null);
  tiersPerPallet: (number|null);
}

export function makeNewProductPackaging(
  input: {
    numberOfItems: (number|null),
    packagingType: ferovinum_app_db.PackagingType,
    gtin: (common_strings.StringNE|null),
    gtinEffectiveDate: (common.LocalDate|null),
    height: (number|null),
    width: (number|null),
    depth: (number|null),
    weight: (number|null),
    casesPerTier: (number|null),
    tiersPerPallet: (number|null),
  }
): NewProductPackaging {
  return {
    numberOfItems: input.numberOfItems,
    packagingType: input.packagingType,
    gtin: input.gtin,
    gtinEffectiveDate: input.gtinEffectiveDate,
    height: input.height,
    width: input.width,
    depth: input.depth,
    weight: input.weight,
    casesPerTier: input.casesPerTier,
    tiersPerPallet: input.tiersPerPallet,
  };
}

const NewProductPackaging_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.product","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"numberOfItems","default":{"kind":"nothing"},"name":"numberOfItems","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}]}},{"annotations":[],"serializedName":"packagingType","default":{"kind":"nothing"},"name":"packagingType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"PackagingType"}},"parameters":[]}},{"annotations":[],"serializedName":"gtin","default":{"kind":"nothing"},"name":"gtin","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"gtinEffectiveDate","default":{"kind":"nothing"},"name":"gtinEffectiveDate","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}]}},{"annotations":[],"serializedName":"height","default":{"kind":"nothing"},"name":"height","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}]}},{"annotations":[],"serializedName":"width","default":{"kind":"nothing"},"name":"width","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}]}},{"annotations":[],"serializedName":"depth","default":{"kind":"nothing"},"name":"depth","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}]}},{"annotations":[],"serializedName":"weight","default":{"kind":"nothing"},"name":"weight","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}]}},{"annotations":[],"serializedName":"casesPerTier","default":{"kind":"nothing"},"name":"casesPerTier","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}]}},{"annotations":[],"serializedName":"tiersPerPallet","default":{"kind":"nothing"},"name":"tiersPerPallet","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Int32"},"parameters":[]}]}}]}},"name":"NewProductPackaging","version":{"kind":"nothing"}}};

export const snNewProductPackaging: ADL.ScopedName = {moduleName:"ferovinum.app.product", name:"NewProductPackaging"};

export function texprNewProductPackaging(): ADL.ATypeExpr<NewProductPackaging> {
  return {value : {typeRef : {kind: "reference", value : snNewProductPackaging}, parameters : []}};
}

export interface NewOrExistingProduct_Existing {
  kind: 'existing';
  value: ferovinum_app_db.ProductId;
}
export interface NewOrExistingProduct_New {
  kind: 'new';
  value: NewProduct;
}

export type NewOrExistingProduct = NewOrExistingProduct_Existing | NewOrExistingProduct_New;

export interface NewOrExistingProductOpts {
  existing: ferovinum_app_db.ProductId;
  new: NewProduct;
}

export function makeNewOrExistingProduct<K extends keyof NewOrExistingProductOpts>(kind: K, value: NewOrExistingProductOpts[K]) { return {kind, value}; }

const NewOrExistingProduct_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.product","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"existing","default":{"kind":"nothing"},"name":"existing","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ProductId"}},"parameters":[]}},{"annotations":[],"serializedName":"new","default":{"kind":"nothing"},"name":"new","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.product","name":"NewProduct"}},"parameters":[]}}]}},"name":"NewOrExistingProduct","version":{"kind":"nothing"}}};

export const snNewOrExistingProduct: ADL.ScopedName = {moduleName:"ferovinum.app.product", name:"NewOrExistingProduct"};

export function texprNewOrExistingProduct(): ADL.ATypeExpr<NewOrExistingProduct> {
  return {value : {typeRef : {kind: "reference", value : snNewOrExistingProduct}, parameters : []}};
}

export interface NewProduct {
  code: common_strings.StringNE;
  name: common_strings.StringNE;
  producerName: common_strings.StringNE;
  productDate: ferovinum_app_db.ProductDate;
  vesselSize: (ferovinum_app_db.VesselSize|null);
  unitType: ferovinum_app_db.UnitType;
  countryOfOrigin: common.Country;
  regionOrigin: string;
  alcoholByVolumePc: ferovinum_app_dtos.AbvValue;
  productType: ferovinum_app_db.ProductType;
  alcoholDetail: ferovinum_app_db.AlcoholDetail;
  vesselType: ferovinum_app_db.VesselType;
  batchRequired: boolean;
  bestBeforeRequired: boolean;
  productPackaging: (NewProductPackaging[]|null);
  parentProductName: (string|null);
  assembledProductComponents: (AssembledProductComponents[]|null);
}

export function makeNewProduct(
  input: {
    code: common_strings.StringNE,
    name: common_strings.StringNE,
    producerName: common_strings.StringNE,
    productDate: ferovinum_app_db.ProductDate,
    vesselSize: (ferovinum_app_db.VesselSize|null),
    unitType: ferovinum_app_db.UnitType,
    countryOfOrigin: common.Country,
    regionOrigin: string,
    alcoholByVolumePc: ferovinum_app_dtos.AbvValue,
    productType: ferovinum_app_db.ProductType,
    alcoholDetail: ferovinum_app_db.AlcoholDetail,
    vesselType: ferovinum_app_db.VesselType,
    batchRequired?: boolean,
    bestBeforeRequired?: boolean,
    productPackaging: (NewProductPackaging[]|null),
    parentProductName: (string|null),
    assembledProductComponents: (AssembledProductComponents[]|null),
  }
): NewProduct {
  return {
    code: input.code,
    name: input.name,
    producerName: input.producerName,
    productDate: input.productDate,
    vesselSize: input.vesselSize,
    unitType: input.unitType,
    countryOfOrigin: input.countryOfOrigin,
    regionOrigin: input.regionOrigin,
    alcoholByVolumePc: input.alcoholByVolumePc,
    productType: input.productType,
    alcoholDetail: input.alcoholDetail,
    vesselType: input.vesselType,
    batchRequired: input.batchRequired === undefined ? false : input.batchRequired,
    bestBeforeRequired: input.bestBeforeRequired === undefined ? false : input.bestBeforeRequired,
    productPackaging: input.productPackaging,
    parentProductName: input.parentProductName,
    assembledProductComponents: input.assembledProductComponents,
  };
}

const NewProduct_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.product","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"code","default":{"kind":"nothing"},"name":"code","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"producerName","default":{"kind":"nothing"},"name":"producerName","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"productDate","default":{"kind":"nothing"},"name":"productDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ProductDate"}},"parameters":[]}},{"annotations":[],"serializedName":"vesselSize","default":{"kind":"nothing"},"name":"vesselSize","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"VesselSize"}},"parameters":[]}]}},{"annotations":[],"serializedName":"unitType","default":{"kind":"nothing"},"name":"unitType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"UnitType"}},"parameters":[]}},{"annotations":[],"serializedName":"countryOfOrigin","default":{"kind":"nothing"},"name":"countryOfOrigin","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Country"}},"parameters":[]}},{"annotations":[],"serializedName":"regionOrigin","default":{"kind":"nothing"},"name":"regionOrigin","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"alcoholByVolumePc","default":{"kind":"nothing"},"name":"alcoholByVolumePc","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.dtos","name":"AbvValue"}},"parameters":[]}},{"annotations":[],"serializedName":"productType","default":{"kind":"nothing"},"name":"productType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ProductType"}},"parameters":[]}},{"annotations":[],"serializedName":"alcoholDetail","default":{"kind":"nothing"},"name":"alcoholDetail","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"AlcoholDetail"}},"parameters":[]}},{"annotations":[],"serializedName":"vesselType","default":{"kind":"nothing"},"name":"vesselType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"VesselType"}},"parameters":[]}},{"annotations":[],"serializedName":"batchRequired","default":{"kind":"just","value":false},"name":"batchRequired","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"bestBeforeRequired","default":{"kind":"just","value":false},"name":"bestBeforeRequired","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"productPackaging","default":{"kind":"nothing"},"name":"productPackaging","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.product","name":"NewProductPackaging"}},"parameters":[]}]}]}},{"annotations":[],"serializedName":"parentProductName","default":{"kind":"nothing"},"name":"parentProductName","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[],"serializedName":"assembledProductComponents","default":{"kind":"nothing"},"name":"assembledProductComponents","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.product","name":"AssembledProductComponents"}},"parameters":[]}]}]}}]}},"name":"NewProduct","version":{"kind":"nothing"}}};

export const snNewProduct: ADL.ScopedName = {moduleName:"ferovinum.app.product", name:"NewProduct"};

export function texprNewProduct(): ADL.ATypeExpr<NewProduct> {
  return {value : {typeRef : {kind: "reference", value : snNewProduct}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.app.product.AssembledProductComponents" : AssembledProductComponents_AST,
  "ferovinum.app.product.NewProductPackaging" : NewProductPackaging_AST,
  "ferovinum.app.product.NewOrExistingProduct" : NewOrExistingProduct_AST,
  "ferovinum.app.product.NewProduct" : NewProduct_AST
};
